<script lang="ts">
  import { toasts, dismiss } from '../lib/toast'
</script>

<div class="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
  {#each $toasts as t (t.id)}
    <div
      class="pointer-events-auto px-4 py-2 rounded-lg shadow-lg border text-sm flex items-center gap-3 backdrop-blur
             {t.type==='ok' ? 'bg-accent-green/15 border-accent-green/40 text-emerald-200' :
              t.type==='err' ? 'bg-accent-red/15 border-accent-red/40 text-red-200' :
              'bg-bg-card/95 border-bg-border text-slate-200'}"
      role="alert"
    >
      <span>{t.message}</span>
      <button class="opacity-60 hover:opacity-100" onclick={() => dismiss(t.id)}>×</button>
    </div>
  {/each}
</div>
